import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import Footer from './Footer';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

function DisclamierMode({ match }) {
  // ** Store Full game **
  const [game, setGame] = useState(null);

  //  ** Store Current selected game mode **
  const [selectedMode, setSelectedMode] = useState(null);

  //  ** Store game mode data **
  const [gameModeData, setGameModeData] = useState({
    game_id: '',
    has_game_mode: false,
    game_mode: [],
  });


  // ** URL parameters **
  const { sceneID, gameID } = match.params;

  // ** Save Game Mode (Update or Insert) **
  const saveGameModeSelection = (gameId, mode) => {
    let existing = JSON.parse(localStorage.getItem('selectedGameMode')) || [];

    const newEntry = {
      gameId,
      gameMode: mode.key,
      gameModeName: mode.name,
      isSetDefault: false,
    };

    const index = existing.findIndex((item) => item.gameId === gameId);

    if (index !== -1) {
      existing[index] = { ...existing[index], ...newEntry };
    } else {
      existing.push(newEntry);
    }

    localStorage.setItem('selectedGameMode', JSON.stringify(existing));
    return newEntry;
  };

  //** Continue to Solution **
  const handleContinue = () => {
    if (!selectedMode) return;
    window.location.href = `/solution:${game._id}/${sceneID}`;
  };

  // **  UseEffects **
  useEffect(() => {
    const gameFinal = JSON.parse(localStorage.getItem('gameFinalScreen')) || [];
    const selectedModes =
      JSON.parse(localStorage.getItem('selectedGameMode')) || [];

    const currentMode = selectedModes.find((gm) => gm.gameId === gameID);
    setSelectedMode(currentMode || null);

    if (gameFinal.length > 0) {
      const gm = gameFinal[0];
      setGame(gm);

      if (gm.has_game_mode && Array.isArray(gm.game_modes)) {
        setGameModeData({
          game_id: gm._id,
          has_game_mode: true,
          game_mode: gm.game_modes,
        });
      }
    }
  }, [gameID]);

  if (!game) return null;

  return (
    <div className='Solution'>
      {/* Logo */}
      {/* <div className='intro-image'>
        <img
          src='/assets/Lock@3x.png'
          alt='Game Icon'
          style={{ width: 70, height: 120 }}
        />
      </div> */}

      <div className='header'>
        <h2 className='solutionTitle'>{game.title}</h2>
      </div>
      <hr />
      {/* Game Title */}
      {/* <h2 style={{ textAlign: 'center', marginTop: 15 }}>{game.title}</h2> */}

      {/* Description */}

      <div
        className='container solution-container'
        style={{ textAlign: 'center' }}
      >
        <div className='media-container'>
          <div>
            <div className='desc-Text-solution'>
              <h3>Choose Your Game Mode</h3>
              <p style={{ fontSize: 16, marginTop: 10, lineHeight: 1.6 }}>
                Welcome to the game! Before we begin, select the mode you want
                to play in.
                <br />
                <br />
                Each mode provides a unique experience—relaxed, balanced, or
                challenging.
                <br />
                <br />
                Your choice affects difficulty, hints, and puzzle style.
              </p>
              {/* Confirmation */}
              {selectedMode && (
                <p style={{ marginTop: 20, fontSize: 17 }}>
                  <strong>
                    Are you sure want to change game mode?
                  </strong>
                </p>
              )}
              {/* Game Mode Buttons */}
              <div className="mode-toggle">
                {gameModeData?.game_mode?.map((mode) => {
                  const isSelected = selectedMode?.gameMode === mode.key;

                  return (
                    <>
                      <input type="radio" name="mode" id={mode.key} checked={isSelected} onClick={() => {
                        const saved = saveGameModeSelection(
                          gameModeData.game_id,
                          mode
                        );
                        setSelectedMode(saved);
                        handleContinue();
                      }} />
                      <label for={mode.key}><strong>{mode.name}</strong></label>
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* Footer */}
      <Footer
        setNewSelectedMode={setSelectedMode}
        isLoginRequired={game.login_required}
        tutorialLink={`/tutorial:${game._id}`}
        gameId={game._id}
      />
    </div>
  );
}

export default withRouter(DisclamierMode);
